var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.get_FlagRebookingShowBookingnoSearchResults
    ? _c("section", { attrs: { id: "content" } }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            {
              staticClass: "block",
              attrs: { id: "contentElementRebookingBookingno" },
            },
            [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("sdr-breadcrumbs", {
                    attrs: { active_item: "first", module: _vm.modulo },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c(
                    "div",
                    { staticClass: "container shortcode travel-ideas" },
                    [
                      _c(
                        "h1",
                        {
                          staticClass: "idea-title",
                          staticStyle: { "margin-bottom": "30px" },
                        },
                        [
                          _vm._m(0),
                          _vm._v(
                            _vm._s(_vm.headline_step1[_vm.getCurrentLocale])
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("sdr-rebooking-bookingno-bookingdetails", {
                    attrs: { modulo: _vm.modulo, mode: "overview" },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sidebar col-sms-6 col-sm-4 col-md-3 topDistance",
                    },
                    [
                      _c("h2", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "search-results-title" }, [
                        _c("i", { staticClass: "soap-icon-search" }),
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.get_RebookingGetBookingResults.passengers
                                .length
                            )
                          ),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.resultsshown[_vm.getCurrentLocale]) +
                            "."
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-arrow-right circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }